import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Stack.module.css';

const gapMap = {
  xs: 'var(--wp-space-8)',
  sm: 'var(--wp-space-12)',
  md: 'var(--wp-space-16)',
  lg: 'var(--wp-space-24)',
  xl: 'var(--wp-space-32)',
} as const;

export type StackGap = keyof typeof gapMap;

export type StackProps = HTMLAttributes<HTMLDivElement> & {
  gap?: StackGap | string | number;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  children: ReactNode;
};

function gapToCss(gap: StackProps['gap']): string | undefined {
  if (gap == null) return gapMap.md;
  if (typeof gap === 'number') return `${gap}px`;
  if (gap in gapMap) return gapMap[gap as StackGap];
  return String(gap);
}

export function Stack({ gap = 'md', align, justify, className, style, children, ...rest }: StackProps) {
  return (
    <div
      className={cx(styles.stack, className)}
      style={{ gap: gapToCss(gap), alignItems: align, justifyContent: justify, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}
